import { axios, API } from './config';

export const recurringWeeklyEventsAPI = {
  list: async () => (await axios.get(`${API}/recurring-weekly-events`)).data,
  create: async (payload) => (await axios.post(`${API}/recurring-weekly-events`, payload)).data,
  update: async (id, payload) => (await axios.put(`${API}/recurring-weekly-events/${id}`, payload)).data,
  remove: async (id) => (await axios.delete(`${API}/recurring-weekly-events/${id}`)).data,
};
